// TODO: Remover?
// TODO: Adicionar método que busca por chave pública do estabelecimento
const chaveSandboxPagSeguro =
    "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAr+ZqgD892U9/HXsa7XqBZUayPquAfh9xx4iwUbTSUAvTlmiXFQNTp0Bvt/5vK2FhMj39qSv1zi2OuBjvW38q1E374nzx6NNBL5JosV0+SDINTlCG0cmigHuBOyWzYmjgca+mtQu4WczCaApNaSuVqgb8u7Bd9GCOL4YJotvV5+81frlSwQXralhwRzGhj/A57CGPgGKiuPT+AOGmykIGEZsSD9RKkyoKIoc0OS8CPIzdBOtTQCIwrLn2FxI83Clcg55W8gkFSOS6rWNbG5qFZWMll6yl02HtunalHmUlRUL66YeGXdMDC2PuRcmZbGO5a/2tbVppW6mfSWG3NPRpgwIDAQAB"

export function criptografarCartaoPagSeguro(cartao) {
    const customParams = JSON.parse(localStorage.getItem("custom-params") ?? "{}")
    const chavePublicaPagseguro = customParams?.PUBLIC_PAGSEGURO_CHAVE_PUBLICA

    if (!chavePublicaPagseguro)
        throw new Error(
            "Chave para criptografar cartão não encontrada. Por favor, contate o estabelecimento."
        )

    return window.PagSeguro.encryptCard({
        publicKey: chavePublicaPagseguro,
        holder: cartao.nomeCartao,
        number: cartao.numeroCartao,
        expMonth: cartao.mesValidade,
        expYear: cartao.anoValidade,
        securityCode: cartao.codigoCartao,
    })
}

export async function criarPedidoPagSeguro(pedido, cartao) {
    // Referência: https://dev.pagbank.uol.com.br/reference/criar-pedido
    try {
        const isCredit = cartao.tipoCartao === "CREDIT_CARD"

        const card = isCredit
            ? {
                  encrypted: cartao.cartaoCriptografado,
                  number: cartao.numeroCartao,
                  expMonth: Number(cartao.mesValidade),
                  expYear: Number(cartao.anoValidade),
                  securityCode: cartao.codigoCartao,
                  store: false,
                  holder: {
                      name: cartao.nomeCartao,
                  },
                  notification_urls: "", // TODO:
                  // splits: []
              }
            : {
                  encrypted: cartao.cartaoCriptografado,
                  number: cartao.numeroCartao,
                  expMonth: Number(cartao.mesValidade),
                  expYear: Number(cartao.anoValidade),
                  securityCode: cartao.codigoCartao,
                  holder: {
                      name: cartao.nomeCartao,
                  },
                  authentication_method: {
                      // type: "",
                      id: "",
                      cavv: "",
                      eci: "",
                      xid: "",
                      version: "",
                      dstrans_id: "",
                      // boleto: {},
                  },
                  notification_urls: "",
                  // splits: []
              }

        const payment_method = isCredit
            ? {
                  type: cartao.tipoCartao,
                  installments: 1,

                  capture: true,
                  // Parâmetro que indica se uma transação de cartão de crédito deve ser apenas pré-autorizada (reserva o valor da cobrança no cartão do cliente de 6 até 29 dias) ou se a transação deve ser capturada automaticamente (cobrança realizada em apenas um passo). ⚠️ Obrigatório para o método de pagamento cartão de crédito. ⚠️ ⚠️ Função indisponível para o método de pagamento cartão de débito e token de bandeira (crédito). ⚠️
                  // - VISA,MASTERCARD e ELO permitirá à captura com cartão de crédito e token de bandeira em até 29 dias(Lista de MCCs disponíveis).
                  // - AMEX e HIPERCARD permitirá à captura apenas com o cartão de crédito e em até 6 dias.
                  // - Informar false para pré-autorizar. Informar true para cobrança em um passo.

                  soft_descriptor: "Compra teste", //TODO: Nome na Fatura do cliente (somente para crédito)
                  card,
              }
            : {
                  type: cartao.tipoCartao,
                  card,
              }

        const charges = [
            {
                reference_id: "", // TODO: Identificador único atribuído para a cobrança
                description: "", // TODO: Descrição da cobrança
                amount: {
                    value: pedido.valorTotal,
                    currency: "BRL",
                },
                payment_method,
            },
        ]

        const shipping = {
            address: {
                street: pedido.end.logradouro,
                number: pedido.end.numero ? Number(pedido.end.numero) : undefined,
                complement: pedido.end.complemento,
                locality: pedido.end.bairro,
                city: pedido.end.cidade,
                region_code: pedido.end.uf,
                country: "BRA",
                postal_code: pedido.end.cep,
            },
        }

        const items = pedido.itens.map(item => ({
            name: item.produto.nome,
            quantity: item.quantidade,
            unit_amount: item.valorProdutoHistorico * 100,
        }))

        const customer = {
            name: pedido.cliente.nome,
            // TODO: Preencher email? Se sim, tratar caso de email da clientefiel.
            // email: pedido.cliente.email,
            tax_id: pedido.cpfTitular ?? pedido.cliente.cpf,
            phones: [{ country: 55, area: 31, number: 999999999, type: "MOBILE" }],
        }

        const requestBody = {
            customer,
            items,
            shipping,
            charges,
        }

        console.log("asdasd requestBody", requestBody)
    } catch (error) {
        console.error(error)
    }
}
